import React from 'react';

import CommonTooltip from '../common-tooltip/CommonTooltip';
import CommonButton from '../common-button/CommonButton';

function TooltipButton({ children, tooltip, maxWidth, ...buttonProps }) {
  return (
    <CommonTooltip title={tooltip}>
      <span style={{ width: '100%', height: 'auto', maxWidth }}>
        <CommonButton {...buttonProps}>{children}</CommonButton>
      </span>
    </CommonTooltip>
  );
}

export default TooltipButton;
